"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPage = createPage;
exports.createPageRoot = createPageRoot;
exports.createAppRoot = createAppRoot;
Object.defineProperty(exports, "asyncComponent", {
  enumerable: true,
  get: function get() {
    return _after.asyncComponent;
  }
});

var React = _interopRequireWildcard(require("react"));

var _after = require("@whys/after");

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function properizeHoc(hoc, name, statics) {
  if (statics.getInitialProps) {
    hoc.getInitialProps = statics.getInitialProps;
  }

  if (statics.RootComponent) {
    hoc.RootComponent = statics.RootComponent;
  }

  if (statics.getRootComponent) {
    hoc.getRootComponent = statics.getRootComponent;
  }

  hoc.displayName = "".concat(name, "(").concat(getDisplayName(hoc), ")");
}

function createPage(config) {
  var Component = config.Component; // ...PageProps, afterMeta: {| dataLoaded: boolean |}

  var Page = function Page(props) {
    var afterMeta = props.afterMeta;
    var dataLoaded = afterMeta && afterMeta.dataLoaded;

    if (!dataLoaded) {
      var Loader = config.Loader;
      return Loader ? React.createElement(Loader, null) : null;
    } // Note: pass even afterMeta because it allows to create HOCs


    return React.createElement(Component, props);
  };

  properizeHoc(Page, 'createPage', config);
  return Page;
} //
// Page root
//


function createPageRoot(config) {
  var Component = config.Component;

  var PageRoot = function PageRoot(props) {
    return React.createElement(Component, props);
  };

  properizeHoc(PageRoot, 'createPageRoot', config);
  return PageRoot;
} //
// App root
//


function createAppRoot(config) {
  var Component = config.Component; // props should be RootProps & { children: any }

  var AppRoot = function AppRoot(props) {
    return React.createElement(Component, props);
  };

  properizeHoc(AppRoot, 'createAppRoot', config);
  return AppRoot;
}